(function(){
  'use strict';

  let modalEl = null;
  let modalOpen = false;
  let savedScrollY = 0;

  function ensureModal(){
    if (modalEl) return modalEl;
    const tpl = document.getElementById('nuvy-size-guide-template');
    if (!tpl) return null;
    const clone = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(clone);
    modalEl = clone;
    bindModalEvents(modalEl);
    return modalEl;
  }

  function openModal(){
    const m = ensureModal();
    if (!m) return;
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    m.classList.add('nuvy-sg__modal--open');
    modalOpen = true;
  }

  function closeModal(){
    if (!modalEl || !modalOpen) return;
    modalEl.classList.remove('nuvy-sg__modal--open');
    modalOpen = false;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  }

  function bindModalEvents(m){
    m.querySelectorAll('[data-sg-close]').forEach(b => b.addEventListener('click', closeModal));
    const backdrop = m.querySelector('[data-sg-backdrop]');
    if (backdrop) backdrop.addEventListener('click', closeModal);
  }

  // Global: any trigger with [data-open-size-guide] opens the modal
  document.addEventListener('click', function(e){
    const trigger = e.target.closest('[data-open-size-guide]');
    if (trigger){
      e.preventDefault();
      openModal();
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && modalOpen) closeModal();
  });
})();
